<template>
    <div class="swiper_rotate4">
        <div class="rotate_box4">
            <!-- <div class="rotate_circle"> -->
            <div class="rotate_pic4"></div>
            <!-- </div> -->
            <!-- <div class="shadow_box"></div> -->
        </div>
        <div class="swiper_box4" v-if="this.$i18n.locale=='zh'">
            <!-- <img :src="item.plugImage" class="bookImg"/>
                  <div class="govenments_content_logo_name">{{ item.plugName }}</div> -->
            <div v-for="(item, index) in dataList" :key="index" class="swiper_div2" @click="openUrl(item.plugUrl)" :style="{ backgroundImage: `url(${item.plugImage})` }">
                <span class="slide-box-small4" >
                   {{item.plugName}}
                </span>
            </div>
        </div>
      <div class="swiper_box4" v-if="this.$i18n.locale=='en'">
        <!-- <img :src="item.plugImage" class="bookImg"/>
              <div class="govenments_content_logo_name">{{ item.plugName }}</div> -->
        <div v-for="(item, index) in dataList" :key="index" class="swiper_div2" @click="openUrl(item.plugUrl)" :style="{ backgroundImage: `url(${item.plugImage})` }">

          <span class="slide-box-small4">
                   {{item.engName}}
                </span>
        </div>
      </div>
        <div id="next3" @click="next()">
            <!-- <svg t="1712474542494" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                p-id="1432">
                <path
                    d="M614.727053 511.42259l-403.237243-403.23724299a63.349415 63.349415 0 1 1 89.622481-89.62248201L749.160776 466.675274a63.349415 63.349415 0 0 1 0 89.494632L301.048367 1004.282315a63.349415 63.349415 0 1 1-89.49463301-89.622482L614.663128 511.42259z"
                    fill="#fff" p-id="1433"></path>
            </svg> -->
            <!-- <i class="el-icon-caret-right next" ></i> -->

        </div>
        <div id="prev4" @click="prev()">
            <!-- <svg t="1712474561555" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                p-id="1630">
                <path
                    d="M409.272947 512.57741l403.237243 403.23724299a63.349415 63.349415 0 1 1-89.622481 89.62248201L274.839224 557.324726a63.349415 63.349415 0 0 1 0-89.494632L722.951633 19.717685a63.349415 63.349415 0 1 1 89.49463301 89.622482L409.336872 512.57741z"
                    p-id="1631" fill="#fff"></path>
            </svg> -->
            <!-- <i class="el-icon-caret-left prev" ></i> -->
        </div>
    </div>

</template>

<script>

import {getnewList, getcolumnsList, getplugList} from "../../api/resouces";

export default {
    data() {
        return {
            currentIndex: 0,
            dataList: ['000001','000002','000003','000004','000005','000006'],
            autoplayInterval: null,
            titleTree: [],
            pid: '',
            classId: 43,
            chgID: 0,
            datalists:[
              {name:"澜沧江-湄公河合作",enName:"Lancang-Mekong Cooperation"},
              {name:"中华人民共和国公安部",enName:"Ministry of Pubic Security of the People's Republic of China"},
              {name:"柬埔寨王国内政部",enName:"Ministry of Interior of the Kingdom of Cambodia"},
              {name:"老挝国防部",enName:"Ministry of National Defense of Lao People's Democratic Republic"},
              {name:"老挝公安部",enName:"Ministry of Public Security of Lao People's Democratic Republic"},
              {name:"柬埔寨国家禁毒委员会",enName:"Cambodia National Authority of Combating Drugs"},
              {name:"泰国皇家警察",enName:"Royal Thai Police"},
              {name:"越南公安部",enName:"Ministry of Public Security of the Socialist Republic of Vietnam"},
              {name:"缅甸警察部队",enName:"Police Force of Republic of the Union of Myanmar"},
              {name:"东盟警察组织",enName:"ASEANAPOL"}
            ],
            imgList: [
                {
                    url: "1"
                },
                {
                    url: "2"
                },
                {
                    url: "3"
                },
                {
                    url: "4"
                },
            ]
        };
    },
    computed: {
        // currentLargeImage() {
        //     return this.dataList.length > 0 ? this.dataList[this.currentIndex].Img : '';
        // },
        // currentSmallImage() {
        //     return this.dataList.length > 0
        //         ? this.dataList[(this.currentIndex + 1) % this.dataList.length].Img
        //         : '';
        // },
    },
    created() {
            this.titleTree = JSON.parse(sessionStorage.getItem('titleTree'))
            getplugList({classification:"0"}).then(res => {
                this.dataList = res.data;
            //   for (let i = 0; i <res.data.length ; i++) {
            //     this.datalists.forEach((item,index)=>{
            //       if(item.name==res.data[i].plugName){
            //         res.data[i].enName=item.enName
            //       }
            //     })
            //   }

                this.dataList = res.data;
                // 确保在数据加载完成后启动自动播放
                if (this.dataList.length > 0) {
                // this.startAutoplay();
                }
            })


    },
    mounted() {
        setTimeout(() => {
        this.init()
        }, 1000);

    },
    methods: {
        init() {
            let next = document.getElementById("next3")
            let prev = document.getElementById('prev4')
            const rotatePic = document.querySelector('.rotate_pic4')
            const swiperBox = document.querySelector('.swiper_box4')
            const swiperDiv = document.querySelectorAll('.swiper_box4 div')
            // swiperDiv[0].style.transform = `scale(1.2)`
            // swiperDiv[0].style.transitionDuration = `1s`
            // function render(index) {
            //     for (let i = 0; i < index; i++) {
            //         rotatePic.innerHTML += `<img src="images/rotate_${i + 1}.png">`
            //     }
            // }
            // render(swiperDiv.length)

            this.chgID = 0

            // next.addEventListener('click', () => {
            //     this.chgID++
            //     this.chgID = this.chgID > swiperDiv.length - 1 ? swiperDiv.length - 1 : this.chgID
            //     this.btnCommon()
            // })
            // prev.addEventListener('click', () => {
            //     this.chgID--
            //     this.chgID = this.chgID < 0 ? 0 : this.chgID
            //     this.btnCommon()
            // })

        },
        next() {
            const swiperDiv = document.querySelectorAll('.swiper_box4 div')
            this.chgID++
            // if (this.chgID + 2 == this.imgList.length) {
            //     let obj = JSON.parse(JSON.stringify(this.imgList[0]))
            //     this.imgList.push(obj)
            // }
            // this.chgID = this.chgID > swiperDiv.length - 2 ? swiperDiv.length - 2 : this.chgID
            this.btnCommon2()
        },
      openUrl(url){
          window.open(url)
      },
        prev() {
            const swiperDiv = document.querySelectorAll('.swiper_box4 div')
            this.chgID--
            // this.chgID = this.chgID < 0 ? 0 : this.chgID
            this.btnCommon2()
        },
        btnCommon() {
            const next = document.querySelector('#next3')  //后一个按钮
            const prev = document.querySelector('#prev4')    //前一个按钮
            const rotatePic = document.querySelector('.rotate_pic4')
            const swiperBox = document.querySelector('.swiper_box4')
            const swiperDiv = document.querySelectorAll('.swiper_box4 div')
            console.log("document.querySelector('.swiper_box4')", swiperDiv[0].style)
            next.style.pointerEvents = this.chgID == swiperDiv.length - 2 ? 'none' : 'auto'   //在划到最后一张或者第一张是否失焦
            prev.style.pointerEvents = this.chgID == 0 ? 'none' : 'auto'
            next.style.opacity = this.chgID == swiperDiv.length - 2 ? .6 : 1    //在划到最后一张或者第一张是否透明
            prev.style.opacity = this.chgID == 0 ? .6 : 1
            // rotatePic.style.transform = `rotate(-${this.chgID * 45}deg)`
            // swiperBox.style.transform = `translateX(-${this.chgID * 100 / swiperDiv.length}%)`
            rotatePic.style.transform = `rotate(-${this.chgID * 45}deg)`
            swiperBox.style.transform = `translateX(-${this.chgID * 100 / swiperDiv.length}%)`
            console.log("this.chgID",this.chgID)
            // for (let i = 0; i < swiperDiv.length; i++) {
            //     if (i == this.chgID) {
            //         swiperDiv[i].style.transform = `scale(1.2)`
            //         swiperDiv[i].style.transitionDuration = `1s`
            //     } else {
            //         swiperDiv[i].style.transform = `scale(1)`
            //         swiperDiv[i].style.transitionDuration = `1s`

            //     }
            // }
        },
        btnCommon2() {
            const next = document.querySelector('#next3')  //后一个按钮
            const prev = document.querySelector('#prev4')    //前一个按钮
            const rotatePic = document.querySelector('.rotate_pic4')
            const swiperBox = document.querySelector('.swiper_box4')
            const swiperDiv = document.querySelectorAll('.swiper_box4 div')
            // next.style.pointerEvents = this.chgID == swiperDiv.length - 2 ? 'none' : 'auto'   //在划到最后一张或者第一张是否失焦
            // prev.style.pointerEvents = this.chgID == 0 ? 'none' : 'auto'
            // next.style.opacity = this.chgID == swiperDiv.length - 2 ? .6 : 1    //在划到最后一张或者第一张是否透明
            // prev.style.opacity = this.chgID == 0 ? .6 : 1
            // rotatePic.style.transform = `rotate(-${this.chgID * 45}deg)`
            // swiperBox.style.transform = `translateX(-${this.chgID * 100 / swiperDiv.length}%)`
            rotatePic.style.transform = this.chgID > swiperDiv.length - 2?`rotate(0deg)`:this.chgID <0?`rotate(-${(swiperDiv.length - 2) * 45}deg)`:`rotate(-${this.chgID * 45}deg)`
            swiperBox.style.transform = this.chgID > swiperDiv.length - 2?`translateX(0%)`:this.chgID <0?`translateX(-${(swiperDiv.length - 2)*100/ swiperDiv.length}%)`:`translateX(-${this.chgID * 100 / swiperDiv.length}%)`
            this.chgID = this.chgID > swiperDiv.length - 2?0:this.chgID <0?this.chgID = swiperDiv.length - 2:this.chgID
            console.log("this.chgID",this.chgID)
            // for (let i = 0; i < swiperDiv.length; i++) {
            //     if (i == this.chgID) {
            //         swiperDiv[i].style.transform = `scale(1.2)`
            //         swiperDiv[i].style.transitionDuration = `1s`
            //     } else {
            //         swiperDiv[i].style.transform = `scale(1)`
            //         swiperDiv[i].style.transitionDuration = `1s`

            //     }
            // }
        },
        imgClick() {
            // console.log("dataList[this.currentIndex]",this.dataList[this.currentIndex])
            this.titleTree.children.forEach((item, index) => {
                // console.log("item",item)
                if (item.children != null) {
                    item.children.forEach((item2, index2) => {
                        if (item2.data.id === this.dataList[this.currentIndex].classId) {
                            this.pid = item2.data.columnPid
                        }
                    })
                }
            });
            this.$router.push({
                path: '/detail',
                query: {
                    pid: this.pid,
                    id: this.classId,
                    detailId: this.dataList[this.currentIndex].id,
                }
            })
        },
        nextImage() {
            this.currentIndex = (this.currentIndex + 1) % this.dataList.length;
            this.resetAutoplay(); // 重置计时器
        },
        prevImage() {
            this.currentIndex = (this.currentIndex - 1 + this.dataList.length) % this.dataList.length;
            this.resetAutoplay(); // 重置计时器
        },
        startAutoplay() {
            this.autoplayInterval = setInterval(() => {
                this.next();
            }, 3000); // 自动播放间隔，单位毫秒
        },
        stopAutoplay() {
            clearInterval(this.autoplayInterval);
        },
        resetAutoplay() {
            this.stopAutoplay();
            this.startAutoplay();
        },
    },
    beforeDestroy() {
        this.stopAutoplay();
    },
    //图片点击跳转事件

};
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
}

.swiper_rotate4 {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
}

.rotate_box4 {
    width: 100%;
    height: 100%;
    /* background: linear-gradient(to right, rgb(178, 71, 253) 30%, rgb(243, 99, 248) 100%); */
    overflow: hidden;
    position: relative;
}

.rotate_circle {
    width: 800px;
    height: 800px;
    position: relative;
    margin: 200px auto;
    border-radius: 50%;
    background: radial-gradient(closest-side, rgb(94, 103, 253) 65%, rgb(18, 187, 253) 100%);
}

.rotate_pic4 {
    width: 50em;
    height: 50em;
    position: relative;
    position: absolute;
    top: -200px;
    left: -200px;
    transition: ease-in-out .5s;
}

.rotate_pic4 img {
    width: 20%;
    height: 100%;
    position: absolute;
    left: 40%;
}

.rotate_pic4 img:nth-child(2) {
    transform: rotate(45deg);
}

.rotate_pic4 img:nth-child(3) {
    transform: rotate(90deg);
}

.rotate_pic4 img:nth-child(4) {
    transform: rotate(135deg);
}

.rotate_pic4 img:nth-child(5) {
    transform: rotate(180deg);
}

.shadow_box {
    width: 100%;
    height: 65%;
    position: absolute;
    top: 400px;
    /* background: linear-gradient(to right, rgb(178, 71, 253) 30%, rgb(243, 99, 248) 100%); */
    filter: blur(15px);

}

.swiper_box4 {
    height: 65%;
    position: relative;
    position: absolute;
    top: 3%;
    left: 0%;
    /* transform: translate(-50%,-50%); */
    display: flex;
    flex-direction: row;
    transition: ease-in-out .5s;
    justify-content: center;
    background-size: cover;
}

.swiper_div2  {
    /* width: calc(4.8vw); */
    width: calc(4.8vw);
    height: 45%;
    /* background: rgb(255, 255, 255, .6); */
    background-image: url(../../assets/img/img_yellow.png);
    margin: 0 calc(1.1vw);
    border-radius: 15px;
  /* font-size: 50px; */
    /* font-weight: 700; */
    /* color: coral; */
    /* 文本居中 */
    display: flex;
    justify-content: center;
    align-items: center;
    background-size: 100% 100%;
    position: relative;
    cursor: pointer;
  transition: transform 0.3s ease;

}
.swiper_div2:hover {
  transform: scale(1.1);
}

#next3,
#prev4 {
    position: absolute;
    /* left: 50%;  */
    top: 40%;
    width: 70px;
    cursor: pointer;
    font-size: 8vh;
    /* transform: translate(-50%, -50%); */
}

#next3 {
    right: 0;
}

#prev4 {
    left: 0;
    /* opacity: .6; */
    /* pointer-events: none; */

}
.slide-box-small4{
  position: absolute;
  top: 110%;
  left: 0%;
  color: #333333;
  /* border-left: #fffefe 0.2em solid; */
  padding-left: 0.5em;
  width: 100%;
  text-align: center;
  font-size: 0.7em;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/carousel/carousel_swiper4.vue